import { render } from "./Students.vue?vue&type=template&id=9833245a&scoped=true"
import script from "./Students.vue?vue&type=script&lang=js"
export * from "./Students.vue?vue&type=script&lang=js"

import "./Students.vue?vue&type=style&index=0&id=9833245a&scoped=true&lang=css"

import exportComponent from "/Users/vncsalencar/Personal/Projects/araruna-anare-rollcall/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9833245a"]])

export default __exports__